module.exports = __webpack_public_path__ + "img/refresh.b2319e88.svg";